module.exports = __webpack_public_path__ + "static/img/withdraw.2a955192.png";